if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        // 2026-09-08: ez a sor a DESKTOPOS nagyito-nezethez keszult (a kep szelesebb a doboznál, ezert kozepre
        // tolja vizszintesen). Mobilon viszont a nagykep mostantol OLDALRA LAPOZ (vizszintes scroll-snap sav), es ez
        // a beallitas minden lapozast visszarantott a megnyitott kepre — merve: a scrollLeft minden probalkozas utan
        // visszaugrott. Mobilon ezert nem futtatjuk; ott a fenti scrollIntoView() allitja a savot a megnyitott kepre.
        const container = this.querySelector('[role="document"]');
        if (window.matchMedia('(min-width: 750px)').matches) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
